import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useTransfersContext} from "../TransfersContext";
import styles from './UnpaidReceiptsStatsPanel.module.scss';

const UnpaidReceiptsStatsPanel = () => {
  const {totalCountUnpaidReceipts} = useTransfersContext();

  return Boolean(totalCountUnpaidReceipts) ? (
    <div className={styles.statsContainer}>
      <span className={styles.statsItem}>
        <FormattedMessage
          id={'transfers-stats-unpaid-totalCount'}
          defaultMessage={'Unpaid receipts {count}'}
          values={{count: totalCountUnpaidReceipts}}
        />
      </span>
    </div>
  ) : null;
};

export default UnpaidReceiptsStatsPanel;
